var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 768.259,
    x2: 3108.801,
    y1: 772.041,
    y2: 3112.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M1938.5 287.3c-263.6 0-512.8 61.6-734 171.3 122.4 206.3 92.4 473.5-81.6 647.4-177.9 177.9-449.7 203.5-655.2 76.9-324 626.3-218.8 1410.3 300.6 1929.7 452.6 452.6 1108.7 592.2 1686.8 402.5-31-70.9-48.1-149.7-48.1-230.2 0-406.2 410.2-683.9 786.6-534.9 51.1 20.2 98.6 47.6 141.4 81 163.7-256.7 258.5-561.6 258.5-888.7 0-914-740.9-1655-1655-1655zM1223.7 2315c-128.3 128.3-336.4 128.5-464.9 0-59.5-59.5-96.3-141.7-96.3-232.4 0-90.8 36.8-173 96.3-232.5 128.3-128.3 336.4-128.5 464.9 0 128.3 128.3 128.5 336.4 0 464.9zm749.6 927.2c-110.8 110.8-290.4 110.9-401.4 0-110.7-110.8-110.9-290.4 0-401.4 110.8-110.8 290.4-110.9 401.4 0 110.8 110.8 110.9 290.4 0 401.4zm82.7-875.8c-156.7 0-283.8-127.1-283.8-283.8s127.1-283.8 283.8-283.8 283.8 127.1 283.8 283.8-127.1 283.8-283.8 283.8zm0-1104.5c-181.6 0-328.7-147.2-328.7-328.7s147.2-328.7 328.7-328.7 328.7 147.2 328.7 328.7-147.2 328.7-328.7 328.7zm1005.3 967.6c-181.6.1-328.8-147.1-328.8-328.7 0-90.8 36.8-173 96.3-232.4 128.3-128.3 336.4-128.5 464.9 0 59.5 59.5 96.3 141.7 96.3 232.4 0 181.5-147.2 328.7-328.7 328.7zM1058.8 1041.9c145.8-145.8 169.3-370 65.7-540.9-253.2 143.3-465.2 351.6-613 602.6 169.6 107 398.1 87.5 547.3-61.7zm-235.9 872.4c-43.1 43.1-69.7 102.6-69.7 168.3 0 131.5 106.6 238 238 238 65.7 0 125.3-26.6 168.3-69.7 93-92.9 93.1-243.6.1-336.6-92.9-92.9-243.6-93-336.7 0zm1096.5 31.7c-75.4 75.4-75.5 197.6 0 273.1 34.9 34.9 83.2 56.6 136.6 56.6 106.7 0 193.1-86.4 193.1-193.1 0-53.3-21.6-101.6-56.6-136.6-75.4-75.4-197.6-75.5-273.1 0zM2056 695.2c-131.4 0-238 106.6-238 238s106.6 238 238 238 238-106.6 238-238-106.6-238-238-238zm-419.9 2209.7c-34.9 34.9-56.6 83.2-56.6 136.6 0 106.7 86.5 193.1 193.1 193.1 53.3 0 101.6-21.6 136.6-56.6 75.3-75.3 75.4-197.6 0-273.1-75.4-75.4-197.6-75.5-273.1 0zm861.5 380c0 68.3 13.6 135.3 42.7 199.6 298.1-116.4 556.9-317.9 743.8-578.4-37.1-29.6-78.8-53.9-123.9-71.8-316.8-125.4-662.6 108.2-662.6 450.6zm563.6-1622.1c-131.5 0-238 106.6-238 238 0 131.5 106.6 238 238 238 65.7 0 125.3-26.6 168.3-69.7 43.1-43 69.7-102.5 69.7-168.3 0-131.5-106.6-238-238-238z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9899ea7b0daff7279f4f6ab9f100ca1b.svg";
export { ForwardRef as ReactComponent };